exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-container[data-v-63edc178]{display:grid;grid-template-columns:1fr;grid-auto-rows:max-content;gap:8px}.grid-container div[data-v-63edc178]{min-height:160px}@media (min-width:722px){.grid-container[data-v-63edc178]{grid-template-columns:1fr 1fr}}@media (min-width:1200px){.grid-container[data-v-63edc178]{grid-template-columns:1fr 1fr 1fr}}", ""]);

// exports
